const GET_APPROVERS_LIST = "GET_APPROVERS_LIST"
const SET_APPROVERS_LIST = "SET_APPROVERS_LIST"

const SAVE_OUT_OF_OFFICE_SETTING = "SAVE_OUT_OF_OFFICE_SETTING"
const IS_OUT_OF_OFFICE_SAVED = "IS_OUT_OF_OFFICE_SAVED"

const GET_CURRENT_OOO_SETTINGS = "GET_CURRENT_OOO_SETTINGS"
const SET_CURRENT_OOO_SETTINGS = "SET_CURRENT_OOO_SETTINGS"

const SAVE_OUT_OF_OFFICE_SETTING_PROFILE = "SAVE_OUT_OF_OFFICE_SETTING_PROFILE"
const IS_OUT_OF_OFFICE_SAVED_PROFILE = "IS_OUT_OF_OFFICE_SAVED_PROFILE"

const GET_CURRENT_OOO_SETTINGS_PROFILE = "GET_CURRENT_OOO_SETTINGS_PROFILE"
const SET_CURRENT_OOO_SETTINGS_PROFILE = "SET_CURRENT_OOO_SETTINGS_PROFILE"

const GET_VALIDATE_BACKUP_APPROVER = "GET_VALIDATE_BACKUP_APPROVER"
const SET_VALIDATE_BACKUP_APPROVER = "SET_VALIDATE_BACKUP_APPROVER"

export {
    GET_APPROVERS_LIST,
    SET_APPROVERS_LIST,
    SAVE_OUT_OF_OFFICE_SETTING,
    IS_OUT_OF_OFFICE_SAVED,
    GET_CURRENT_OOO_SETTINGS,
    SET_CURRENT_OOO_SETTINGS,
    SAVE_OUT_OF_OFFICE_SETTING_PROFILE,
    IS_OUT_OF_OFFICE_SAVED_PROFILE,
    GET_CURRENT_OOO_SETTINGS_PROFILE,
    SET_CURRENT_OOO_SETTINGS_PROFILE,
    GET_VALIDATE_BACKUP_APPROVER,
    SET_VALIDATE_BACKUP_APPROVER
}